<template>
  <div class="comment" :class="getCommentClass()">
    <p v-html="asHtml(comment.text)">
    </p>
    <div class="comment-title">
      <div>
        <em class="owner">{{ comment.profile.name }}</em>
        <span class="profile"> ({{ comment.profile.profileTypeDisplay }})</span>
        <!-- Description of foreign user -->
        <template v-if="comment.isSwitched()">
          <em class="owner"> switched from {{ comment.user.profile.name }}</em>
          <span class="profile"> ({{ comment.user.profile.profileTypeDisplay }})</span>
        </template>
      </div>
      <div class="date">{{ comment.created }}</div>
    </div>
  </div>
</template>
<script>
  import { linkifyComment } from '@/utility/utility_functions'

  export default {
    name: 'comment-finding-component',
    props: {
      comment: {
        type: Object,
        required: true
      }
    },
    methods: {
      asHtml (content) {
        return content.length ? linkifyComment(content) : content
      },
      getCommentClass () {
        return {
          'auditor-comment': this.comment.profile.isAuditor(),
          'customer-comment': this.comment.profile.isCustomer()
        }
      }
    }
  }
</script>
